import React from 'react';
import './CountryRadioSelector.less';
import Flag from 'react-world-flags';

export type CountryOption = {
  code: string;
  label: string;
};

type Props = {
  options: CountryOption[];
  value?: string;
  onChange: (code: string) => void;
  className?: string;
  testid?: string;
};

const CountryRadioSelector: React.FC<Props> = ({
  options,
  value,
  onChange,
  className,
  testid,
}) => {
  return (
    <div
      data-testid={testid}
      role="radiogroup"
      className={`country-radio-selector ${className || ''}`}
    >
      {options.map((opt, index) => {
        const checked = value === opt.code;
        const code = opt.code === 'EL' ? 'GR' : opt.code;
        return (
          <div key={opt.code}>
            <div
              role="radio"
              aria-checked={checked}
              className="country-radio-selector-row"
              onClick={() => onChange(opt.code)}
            >
              <div className="country-radio-selector-flag">
                <Flag code={code} height={16} />
              </div>
              <div className="country-radio-selector-label">{opt.label}</div>
              <div className="country-radio-selector-right">
                <input
                  type="radio"
                  className="country-radio-input"
                  checked={checked}
                  onChange={() => onChange(opt.code)}
                />
              </div>
            </div>
            {index < options.length - 1 && (
              <div className="country-radio-selector-separator" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CountryRadioSelector;
